module.exports = __webpack_public_path__ + "img/f3-3.4720e1a1.png";